import { Button } from "../../../components/forms";
import { GoPlus } from "react-icons/go";
import { ListPicker } from "../../../components/generic/ListPicker";
import { usePickerhook } from "../../../hooks/usePickerhook";
import { SearchBar } from "../../../components/generic/SearchBar";
import { useEffect, useState } from "react";
import { useDeptHook } from "../../../hooks/useDeptHook";
import { NoEmployee } from "../../../components/users/NoEmployee";
import AddEmployee from "../../../components/Modules/Employees/AddEmployee";
import EmployeeItem from "./EmployeeItem";
import useDepartmentHook from "../../../hooks/useDepartmentHook";
import useEmployeeHook from "../../../hooks/useEmployeeHook";
import AddPosition from "../../../components/Modules/Employees/AddPositionModal";
import usePositionHook from "../../../hooks/usePositionHook";
import AddPositionModal from "../../../components/Modules/Employees/AddPositionModal";
import PositionItem from "./PositionItem";
import NavigatebackBtn from "../../../components/generic/NavigateBackBtn";
import { useNavigate } from "react-router-dom";
import AddSubordinates from "../../../components/Modules/Employees/AddSubordinates";
import { useStateGetter } from "../../../hooks/statehooks/UseStateGettersHook";
import { useStateSetter } from "../../../hooks/statehooks/UseStateSettersHook";
import { toast } from "react-toastify";
import { onGetSubordinates } from "../../../services/employee";
import { Employees } from "./Employees";

export default ()=> {
  const [showadddept, setshowadddept] = useState(false);
  const navigate = useNavigate();
  const [entered, setentered] = useState("");
  const { config, selectedEmployee } = useStateGetter();
  const [subordinates, setsubordinates] = useState([]);
  const { setLoading , setSidebarRenderView} = useStateSetter();
  const { AddPosition, refresh, allorgPositions } = usePositionHook();
  const onChange = (e: string) => {
    setentered(e);
  };

  const getSubs = async () => {
    try {
      setLoading(true);

      var response = await onGetSubordinates(selectedEmployee.id, config);
      setsubordinates(response.data);
    } catch (e: any) {
      toast.error(e);
    } finally {
      setLoading(true);
    }
  };

  useEffect(()=>{
    getSubs()


  },[])

  return (
    <div className="w-full pr-20  flex  ">
      {showadddept && (
        <AddSubordinates
          AddPosition={AddPosition}
          allorgPositions={allorgPositions}
          refresh={getSubs}
          show={setshowadddept}
        />
      )}
      <div className={` p-6 bg-white    w-full  rounded-[20px]`}>
        <div className="  w-full  flex justify-between items-center  ">
          <div className="flex justify-center items-center">
            <NavigatebackBtn
              style={"!inline mr-2  mb-2"}
              onclick={() => {
                setSidebarRenderView(<Employees/>)
              }}
            />
            <p className="!inline text-textbg font-medium text-sm mb-2 text-[16px] bg-white">
              Subordinates({subordinates.length})
            </p>
          </div>

          <Button
            width={200}
            disabled={false}
            text={
              <>
                {" "}
                <GoPlus size={15} className=" mx-1 inline" /> Add Subordinate
              </>
            }
            onBtnClick={() => {
              setshowadddept(true);
            }}
          />
        </div>

        <hr />


        {subordinates.length > 0 ? (
          <div className=" grid grid-cols-2 gap-4 py-4">
            {subordinates.map((i: any) => (
              <EmployeeItem item={i.subordinate} />
            ))}
          </div>
        ) : (
          <div className="flex justify-center items-center my-4">
           <p className="text-primary">No Subordinate </p>
          </div>
        )}
      </div>
    </div>
  );
};
